import React from "react";
import { Nav } from "../layouts/headernew";
import "../style/terms.css";
import { ToothZapFooter2 } from "../layouts/footernew";
export const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <Nav />

      {/* LEGAL SECTION */}
      <section className="legal-section">
           <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-date">Last updated: March 13, 2026</p>

          <div className="legal-content">
            <p>
              ToothZap collects contact and business information that users choose to
              submit through forms, demo requests, and partner enquiries on the
              website. This may include names, email addresses, phone numbers, clinic
              or lab names, city details, and any additional information voluntarily
              entered into message fields.
            </p>

            <p>
              That information is used to respond to enquiries, arrange demos,
              evaluate network fit, improve workflow operations, and maintain
              communication with clinics, milling hubs, and prospective partners.
              ToothZap does not treat website enquiry data as public content and does
              not publish submitted form information without a separate operational or
              contractual basis.
            </p>

            <p>
              ToothZap may use infrastructure providers, analytics tools, scheduling
              tools, customer communication systems, or CRM platforms to operate the
              service. Data shared with those providers is limited to the information
              reasonably necessary to run the workflow, contact users, manage
              relationships, and improve service delivery.
            </p>

            <p>
              Users may request correction or deletion of their submitted information,
              subject to any legal, contractual, or operational retention requirements
              that apply at the time of the request. ToothZap also reserves the right
              to retain records needed to investigate abuse, prevent fraud, or
              document legitimate business communication.
            </p>

            <p>
              This Privacy Policy may be updated when data handling practices,
              tooling, or legal requirements change. The latest version will always be
              posted on this page, and the posted update date indicates when the most
              recent revision became effective.
            </p>
          </div>
        </div>
         </div>
        </div>
      </section>

      <ToothZapFooter2 />
    </div>
  );
};

export default PrivacyPolicy;